import { List } from '../../formElements';

export const getFoundLists = (suppressionListIds: string[], fetchedLists: List[]) =>
  suppressionListIds.reduce(
    (acc: Record<string, string[]>, id) => {
      const foundList = fetchedLists.find((list) => list.id?.toString() === id);
      return {
        found: [...acc.found, ...(foundList ? [id] : [])],
        notFound: [...acc.notFound, ...(!foundList ? [id] : [])],
      };
    },
    {
      found: [],
      notFound: [],
    },
  );
